import { useEffect, useRef } from 'react';
import type { Chapter } from '@gbcmc/survey-core';
import { ChapterArt } from '../components/ChapterArt';
import { BrandMark } from '../components/BrandMark';
import { PrimaryButton } from '../components/Buttons';

interface ChapterTransitionProps {
  chapter: Chapter;
  onContinue: () => void;
  isFirst: boolean;
}

// Transición de capítulo: celebra el avance (handoff §11.2).
export function ChapterTransition({ chapter, onContinue, isFirst }: ChapterTransitionProps) {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    headingRef.current?.focus();
  }, [chapter.id]);

  return (
    <main className="gb-screen gb-screen--transition gb-anim">
      <BrandMark className="gb-transition__badge" />
      <div className="gb-transition__art" aria-hidden="true">
        <ChapterArt kind={chapter.illustration} />
      </div>
      {!isFirst ? (
        <p className="gb-transition__done">
          <span className="gb-transition__check" aria-hidden="true">
            ✓
          </span>
          ¡Capítulo {chapter.num - 1} completado!
        </p>
      ) : (
        <p className="gb-transition__done gb-transition__done--first">Comencemos</p>
      )}
      <p className="gb-transition__kicker">Capítulo {chapter.num}</p>
      <h1 className="gb-transition__title" tabIndex={-1} ref={headingRef}>
        {chapter.title}
      </h1>
      <p className="gb-transition__intro">{chapter.intro}</p>
      <PrimaryButton gold onClick={onContinue}>
        {isFirst ? 'Empezar el capítulo' : 'Siguiente capítulo'}
      </PrimaryButton>
    </main>
  );
}
